import PropTypes from 'prop-types';
import React from 'react';
import { Image } from 'react-bootstrap';
import Avatar from 'react-avatar';
import moment from 'moment';


function renderImage(src, name) {
  if (src) {
    return (
      <Image src={src} responsive className="avatar" />
    );
  }
  return (
    <Avatar name={name} color="#326a34" size={75} className="avatar" />
  );
}

class TourHeader extends React.Component {
  // constructor(props) {
  //   super(props);
  // }
  tourDate() {
    const start = moment(this.props.tour.start);
    const end = moment(this.props.tour.end);
    if (start.isValid()) {
      return `${start.format('MMMM Do YYYY')} - ${end.format('MMMM Do YYYY')}`;
    }
    return '';
  }

  render() {
    const image = renderImage(this.props.tour.image, this.props.tour.name);
    // const tourDate = this.tourDate();

    return (
      <div className="tour-header">
        { image }
        <div className="tour-title">
          <h2>{ this.props.tour.name }: <span>{ this.props.tour.tag_line }</span></h2>
          <div className="tour-info">
            <div className="tour-date"> </div>
          </div>
        </div>
        <div className="col-sm-6">
          <div className="pull-right">
            <h2>{ this.props.tour.travel_agency.name }</h2>
            <p>IATA# { this.props.tour.travel_agency.iata }</p>
          </div>
          <Avatar
            name={this.props.tour.travel_agency.name}
            src={this.props.tour.travel_agency.logo}
            size={75}
            className="pull-right avatar"
          />
          <div className="clearfix" />
        </div>
      </div>
    );
  }
}


TourHeader.propTypes = {
  tour: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    tag_line: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    image: PropTypes.string,
    start: PropTypes.string,
    end: PropTypes.string,
    created_on: PropTypes.string,
    updated_on: PropTypes.string,
    sent_to_manager: PropTypes.string,
    travel_agency: PropTypes.number,
    notes: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
};

TourHeader.defaultProps = {
  tour: {
    state: 'draft',
    start: null,
    end: null,
    image: 'https://www.whyy.org/img/ontour_logocrop.png',
  },
};

export default TourHeader;



// WEBPACK FOOTER //
// src/routes/booking/components/TourHeader.js